import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Form, Input, Spin } from "antd";
import toast from "react-hot-toast";
import { LoginOtpVeryficationApi, ResendOtpApi } from "../../api/request/auth";
import { setloggedIn, setUserDetails } from "../../store/Slices/userSlice.js";
import LoadableButton from "../../components/button/LoadableButton";
import { setCookies } from "../../services/Cookies.jsx";
import RightArrow from "../../assets/RightArrow.jsx";

const Otp = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const email = localStorage.getItem("email");
  const [initialValues] = useState({ otp: "" });
  const [isOtpLoading, setIsOtpLoading] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [timer, setTimer] = useState(0);

  useEffect(() => {
    setTimer(120);
    const interval = setInterval(() => {
      setTimer((current) => (current !== 0 ? current - 1 : 0));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const formattedTime = useMemo(() => {
    const minutes = Math.floor(timer / 60);
    const remainingSeconds = timer % 60;
    return `${String(minutes).padStart(2, "0")}:${String(
      remainingSeconds
    ).padStart(2, "0")}`;
  }, [timer]);

  const handleSubmit = async (values) => {
    try {
      setIsOtpLoading(true);
      const params = { ...values, email };
      const { data } = await LoginOtpVeryficationApi(params);
      if (data?.status) {
        setCookies("token", data?.token);
        dispatch(setloggedIn(true));
        dispatch(setUserDetails(data?.data));
        localStorage.removeItem("email");
        form.resetFields();
        toast.success(data?.message);
        navigate("/dashboard");
      } else {
        toast.error(data?.message);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
    } finally {
      setIsOtpLoading(false);
    }
  };

  const handleResend = async () => {
    try {
      setLoading(true);
      const { data } = await ResendOtpApi({ email });
      if (data?.status) {
        toast.success(data?.message);
        setTimer(120);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to resend OTP");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="xl:w-3/5 md:w-[80%] w-full sm:p-0 p-4">
      <Form
        autoComplete="off"
        onFinish={handleSubmit}
        form={form}
        initialValues={initialValues}
        className="space-y-8"
      >
        <div className="text-center">
          <p className="page-title mb-3">OTP Verification</p>
          <p className="text-sm text-Gray">
            {`A security code has been sent to ${email}.`} <br />
            {`Please enter the code below to continue.`}
          </p>
        </div>

        <Form.Item
          name="otp"
          rules={[{ required: true }]}
          className="flex justify-center"
        >
          <Input.OTP size="large" style={{ width: "100%" }} />
        </Form.Item>

        <div className="text-center">
          {isLoading ? (
            <Spin />
          ) : timer > 0 ? (
            <p className="sub-title text-sm">
              Didn't receive it?{" "}
              <span
                className="text-primary font-bold cursor-pointer"
                title="You can request a new code after the timer ends"
              >
                {formattedTime}
              </span>
            </p>
          ) : (
            <p className="sub-title flex justify-center w-full">
              Didn't receive it?
              <span
                className="text-primary font-bold underline ml-1 cursor-pointer"
                onClick={handleResend}
              >
                Resend
              </span>
            </p>
          )}
        </div>

        <LoadableButton
          isLoading={isOtpLoading}
          type="submit"
          lable="Verify"
          loadingLabel="Verifying otp..."
          className={"w-full"}
        >
          Verify <RightArrow />
        </LoadableButton>

        <div className="text-primary flex items-center justify-center mb-5">
          <img src="assets/icons/ArrowLeft.svg" alt="icon" className="me-3" />
          <Link to="/login">Back to login</Link>
        </div>
      </Form>
    </div>
  );
};

export default Otp;
